module.exports = __webpack_public_path__ + "img/chat-reminder-icon.a021cb4d.svg";